<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>edit</mat-icon>
      {{ Organisation?.title }}
    </h1>
  </section>
  <section mat-dialog-content>
    <carousel-images-view
      [DataSource]="CarouselImageDataSource"
      [editable]="true"
    ></carousel-images-view>
    <quill-editor
      class="form-control"
      formControlName="description"
    ></quill-editor>
    <mat-form-field>
      <mat-label>Sub offer title</mat-label>
      <input formControlName="offer_label" matInput />
      <mat-hint>for example 'Save' or 'Special event'</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Main Offer title</mat-label>
      <input formControlName="offer" matInput />
      <mat-hint>for example '50% OFF' or 'Eurostar'</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Additional Offer Info</mat-label>
      <input formControlName="offer_terms" matInput />
      <mat-hint
        >for example 'valid 7 days a week' or 'only &pound;140 per person for 7
        days'</mat-hint
      >
    </mat-form-field>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid || loading"
      mat-button
      matTooltip="Save organisation."
      type="submit"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
